import styled from 'styled-components';

export const StyledDateInput = styled.input.attrs((props) => ({
  name: props.name,
  id: props.name
}))<{ inputSize: 'small' | 'medium' | 'big' }>`
  border-radius: ${({ theme }): string => theme.border_radius_x2};
  background-color: ${({ theme }): string => theme.palette_blue_0};
  color: ${({ theme }): string => theme.palette_gray_60};
  border-color: transparent;
  width: 120px;
  text-align: center;
  height: ${({ inputSize }): string => {
    if (inputSize === 'small') {
      return '24px';
    }
    if (inputSize === 'medium') {
      return '32px';
    }
    return '48px';
  }};
  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`;

export const StyledDateInputAlt = styled.input`
  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme }): string => theme.palette_gray_5};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  height: ${({ theme }): string => theme.spacing_unit_x4};
`;
